// @flow

import CustomField from "./CustomField"
import Input from "./Input.js"
import Error from "./Error"

const InputField = CustomField(Input, Error)

export default InputField



// WEBPACK FOOTER //
// ./src/UI/Form/InputField.js